import React from 'react';
import type { Props } from './imageLoader.types';
import { ImageWrapper } from './imageLoader.styles';

const ImageLoader = ({ src }: Props) => <ImageWrapper src={src} />;

export default ImageLoader;
